import { render, staticRenderFns } from "./HostInvoicesList.vue?vue&type=template&id=0d6d3490&"
import script from "./HostInvoicesList.vue?vue&type=script&lang=js&"
export * from "./HostInvoicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports